/*!
 * Date: 2026/1/25
 * <p>
 * Copyright (c) 2026, zhaotao All Rights Reserved.
 *
 * @author zhaotao
 */
import axios from "axios";
import {envs} from "@/main/envs";

async function getLatest() {
  const seed = new Date().getTime().toString(36);

  const flavor = envs.flavor;

  const http = await axios.get(envs.baseUri + `/versions/sorted?flavor=${encodeURIComponent(flavor)}&_=${seed}`)

  const data = http.data?.items;

  if ( !data || data.length === 0 ) {
    return;
  }

  const version = data[0];

  const latest = {
    windows: [],
    macos: [],
  };

  version.assets.forEach((asset) => {
    let os_type;
    let os_name;
    switch (asset.platform) {
      case 'osx_arm64':
        os_type = 'macos';
        os_name = ' Apple 芯片版(Mac)'; break;
      case 'osx_64':
        os_name = ' Intel 芯片版(Mac)';
        os_type = 'macos'; break;
      case 'windows_64':
        os_name = 'Windows版本';
        os_type = 'windows'; break;
      default:
        return;
    }

    const baseUri = `/download/flavor/${flavor}/${version.name}`;

    const buttons = latest[os_type];

    const href = `${baseUri}/${asset.platform}/${asset.name}`;

    switch (asset.filetype) {
      case '.exe':
        buttons.push({
          name: `下载${os_name}`,
          href: href,
          asset: asset,
        })
        break;
      case '.dmg':
        buttons.push({
          name: `下载${os_name}`,
          href: href,
          asset: asset,
        })
    }

  });

  return latest;
}

export const Versions = {
  getLatest
}
